import { privateAxios } from "../axiosInstances";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import conversationKeys from "../query-keys/conversations.query-keys";
import { Conversation, ConversationSummary } from "@ac-expo/api-types";
import { uniqueId } from "lodash";

export interface SendMessageData {
  messageContent: string;
  toUserId: string;
}

const sendMessage = async (data: SendMessageData) => {
  const response = await privateAxios.post("/conversation", data);
  return response.data;
};

export function useSendMessageMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: sendMessage,
    onSuccess: (_, variables) => {
      queryClient.setQueryData(
        conversationKeys.detail(variables.toUserId),
        (old: Conversation) => {
          return {
            ...old,
            messages: [
              {
                id: uniqueId(),
                content: variables.messageContent,
                sentAt: new Date().toISOString(),
                isRead: true,
                senderId: "",
              },
              ...(old?.messages ?? []),
            ],
          };
        }
      );
      queryClient.invalidateQueries({
        queryKey: conversationKeys.lists(),
      });
    },
  });
}

const archiveConversation = async (conversationId: string) => {
  const response = await privateAxios.post(
    `/conversation/${conversationId}/archive`
  );
  return response.data;
};

export function useArchiveConversationMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: archiveConversation,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: conversationKeys.lists(),
      });
    },
  });
}
